import { connect, useDispatch } from "react-redux";
import React, { useEffect } from "react";
import styled from "styled-components";
import ProfileMenu from "../../Perfil/ProfileMenu/ProfileMenu";
import MisProyectos from "../MisProyectos/MisProyectos";
import { getAdjudicatedById, openFeedTextModal } from "../../../store/actions";
import { Link } from "react-router-dom";
import Layout from "../../Layout/Layout";
import ProjectId from "../../Dashboard/project/projectId";

const Container = styled.div`
  padding-top: 100px;
  display: flex;
  justify-content: center;
  width: 100%;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin:30px 10px;
  width: 100%;
  &.isVisualizerOpen {
    max-height: 1500px;
    overflow: hidden;
  }
  @media (max-width: 900px) {
    width: 100%;
    max-width: auto;
    min-width: auto;
  }
`;

const ProjectsPostulationsWrapper = styled.div`
  top: 98px;
  left: 0;
  height: 100%;
  width: 100%;
  max-width: 313px;
  @media (max-width: 900px) {
    display: flex;
  }
`;
const OverflowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 313px;
  @media (max-width: 900px) {
    display: flex;
    background-color: red;
  }
`; 
const Adjudicados = ({openFeedTextModal, ...props}) => {
  const dispatch = useDispatch();
  //se obtiene el id por parametro o por props de url
  const id = props?.location?.state?.id || props?.match?.params?.id;

  useEffect(() => {
    dispatch(getAdjudicatedById(id));
  }, []);

  const existingUser = props?.project?.user?.id;

  return (
    <Layout>
      <Container>
        <Wrapper>
          <ProjectId item={props.project} isAdjudicated />
        </Wrapper>
        <ProjectsPostulationsWrapper>
          <OverflowWrapper>
            {props?.profileMenu ? <ProfileMenu /> : null}
            {!existingUser ? (
              <Link to="/register">
                <MisProyectos />
              </Link>
            ) : (
              <MisProyectos />
            )}
          </OverflowWrapper>
        </ProjectsPostulationsWrapper>
      </Container>
    </Layout>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    profileMenu: state.profile.menuShow,
    project: state.profile.project,
    auth: state.general.isAuth,
  };
};

export default connect(mapStateToProps, { getAdjudicatedById, openFeedTextModal })(Adjudicados);
